<template>
    <div class="footer">      
      <div class="container">
        <div class="row footer-wrap">
          <div class="col-sm-7 col-lg-8">
            <div>
              <slot name="top"><p>&nbsp;</p></slot>
            </div>
          </div>
          <div class="col-sm-5 col-lg-4 footer-link-container"> 
            <b><router-link to="/claimsguide">Help</router-link></b>
            <span> | </span>
            <b><router-link to="contact">Contact</router-link></b>
            <span> | </span>
            <b><a href="https://www.taurus.gi/privacy" target="_blank">Privacy</a></b>
          </div>          
        </div>      
        
        <div class="row">
          <div class="col-12">
            <slot name="main"></slot>
            <slot name="copyright"></slot>
          </div>
        </div>
      </div> 
      <div class="footer-svg-container"></div>     
    </div>
</template>

<script>

export default {
  name: 'PageFooterV2'
}
</script>
